module.exports = Promise;



//////////////////
// WEBPACK FOOTER
// ./node_modules/any-promise/any-promise-shim.js
// module id = 493
// module chunks = 1